module.exports = __webpack_public_path__ + "img/image.54d12503.png";